

























import { Vue, Component } from "vue-property-decorator";
import { getSelectObject } from "../../../../api";
import ObjectLayout from "./layout.vue";
@Component({
  name: "SelectObject",
  components: { ObjectLayout }
})
export default class SelectObject extends Vue {
  private visible: boolean = false;
  private title: string = "表单信息";

  private meta: any = {};
  private list: any[] = [];

  private top: string = "15vh";

  beforeOpen() {
    const dialog = this.$el.querySelector(".el-dialog") as HTMLDivElement;
    const drect = dialog.getBoundingClientRect();
    const brect = document.body.getBoundingClientRect();
    this.top = (brect.height - drect.height) / 2 + "px";
  }

  async getSelectObject(params: any) {
    try {
      const { success, data, meta } = await getSelectObject(params);
      if (!success) {
        this.$message.error("查询表单信息失败");
      } else {
        this.title = meta.description;
        this.meta = meta;
        this.list = data;
      }
    } catch (error) {
      this.$message.error("查询表单信息失败");
    }
  }

  async show(params: any) {
    await this.getSelectObject(params);
    this.visible = true;
  }
}
